import script from "./ProductGridTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductGridTile.vue?vue&type=script&setup=true&lang=js"

import "./ProductGridTile.vue?vue&type=style&index=0&id=671edd9d&lang=scss"

const __exports__ = script;

export default __exports__